const tData = {
    en: {
      proof:(
        <>
          Hi! We're{" "}
          <span className="light-bold">Proof.</span>
        </>
      ),
      work: "Work",
      about: "About",
      email: "Email us",
      headline: "Fresh and imaginative experiences for the internet and elsewhere.",
      testimonials: "From our clients",
      rights: "© 2025 Proof Agency, LLC · M/WBE-Certified NYC",
      lang: "En Español",
      lorem: "Riddim Ipsum",
      heading: "Oops this page doesn’t exist!",
      text: "Return to projects",
      aboutHeader: (
        <>
          Proof is the design and technology practice of{" "}
          <a href="https://segacyroberts.com/" target="_blank" className="underline"><i>Segacy</i></a> and{" "}
          <a href="https://mariamergal.dev/" target="_blank" className="underline"><i>Maria</i></a>, two childhood friends from NYC.
        </>
      ),
      aboutText: (
        <>
          Thanks for stopping by! In our independent careers, we’ve had the pleasure of working for companies like{" "}
          <a href="http://www.spotify.com/" target="_blank">Spotify</a>,{" "}
          <a href="https://www.bookofthemonth.com/" target="_blank">Book of the Month</a>, and{" "}
          <a href="https://academiccme.com/" target="_blank">AcademicCME</a>. We love building things for thoughtful and imaginative people looking to make an impact.
          <br />&nbsp;
          <br />
          When we’re not at our desks, we love traveling, reading, and hanging out without purpose. We’d love to work together! Get in touch by emailing us at{" "}
          <a href="mailto:hello@itsproof.co">hello@itsproof.co</a>.
        </>
      ),
      servicesHeading: "Services",
      capabilitiesHeading: "Capabilities",
      services: ["Strategy", "Web Design & Development", "App Design & Development", "Branding", "Digital Design", "Copywriting & Editing"],
      capabilities: ["Informational websites", "Editorial platforms", "Portfolios & microsites", "Pitch & tone decks", "Online shops", "Third-party integrations"],
      sundayNote: (
        <>
          As a part of the Proof family, we’ve created{" "}
          <a href="https://sundaylighthouse.itsproof.co/" target="_blank" className="underline">Sunday Lighthouse</a>, dedicated to projects in the wellness space.
        </>
      )
    },
    es: {
      proof:(
        <>
          ¡Hola! Somos{" "}
          <span className="light-bold">Proof.</span>
        </>
      ),
      work: "Trabajo",
      about: "Acerca de",
      email: "Contáctanos",
      headline: "Experiencias frescas e imaginativas para el internet y más allá.",
      testimonials: "De parte de nuestros clientes",
      rights: "© 2025 Proof Agency, LLC · Certificación de M/WBE en NYC",
      lang: "In English",
      lorem: "Ritmo Ipsum",
      heading: "¡Perdona! Esta página no existe.",
      text: "Volver a proyectos",
      aboutHeader: (
        <>
          Proof es la práctica de diseño y tecnología de{" "}
          <a href="https://segacyroberts.com/" target="_blank" className="underline">Segacy</a> y{" "}
          <a href="https://mariamergal.dev/" target="_blank" className="underline">Maria</a>, dos amigas de la infancia de Nueva York.
        </>
      ),
      aboutText: (
        <>
          ¡Gracias por visitarnos! En nuestras carreras independientes, hemos tenido el placer de trabajar para compañías como{" "}
          <a href="http://www.spotify.com/" target="_blank">Spotify</a>,{" "}
          <a href="https://www.bookofthemonth.com/" target="_blank">Book of the Month</a> y{" "}
          <a href="https://academiccme.com/" target="_blank">AcademicCME</a>. Nos encanta crear para personas reflexivas e imaginativas que buscan generar impacto.
          <br />&nbsp;
          <br />
          Cuando no estamos en nuestros escritorios, nos encanta viajar, leer y pasar el tiempo sin un propósito específico. ¡Nos encantaría trabajar contigo! Escríbenos a{" "}
          <a href="mailto:hello@itsproof.co">hello@itsproof.co</a>.
        </>
      ),
      servicesHeading: "Servicios",
      capabilitiesHeading: "Capacidades",
      services: ["Estrategia", "Diseño y desarrollo web", "Diseño y desarrollo de apps", "Branding", "Diseño digital", "Redacción y edición"],
      capabilities: ["Sitios web informativos", "Plataformas editoriales", "Portafolios y micrositios", "Presentaciones y tono", "Tiendas en línea", "Integraciones con terceros"],
      sundayNote: (
         <>
          Como parte de la familia Proof, hemos creado{" "}
          <a href="https://sundaylighthouse.itsproof.co/" target="_blank" className="underline">Sunday Lighthouse</a>, dedicado a proyectos en el espacio de bienestar.
        </>
      )
    }
  };
  
  export default tData;